export const WEBSITE_SETTINGS_DEFAULTS = {
    institutionName: 'Universitas Pertiba',
    systemTitle: 'Letter of Acceptance',
    footerText: '© Universitas Pertiba. All rights reserved.',
};

export function buildDocumentTitle(settings = {}) {
    const { systemTitle, institutionName } = settings;
    if (systemTitle && institutionName) {
        return `${systemTitle} — ${institutionName}`;
    }
    return systemTitle || institutionName || WEBSITE_SETTINGS_DEFAULTS.systemTitle;
}

export function buildMetaDescription(settings = {}) {
    const { systemTitle, institutionName } = settings;
    if (systemTitle && institutionName) {
        return `Portal resmi ${systemTitle} ${institutionName} untuk verifikasi LOA, manajemen jurnal, dan layanan publikasi artikel.`;
    }
    return systemTitle || institutionName || buildDocumentTitle(settings);
}

export function buildSiteMetaBundle(settings = {}, { siteUrl = '', imageUrl = '' } = {}) {
    const title = buildDocumentTitle(settings);
    const description = buildMetaDescription(settings);
    const siteName = settings.institutionName || WEBSITE_SETTINGS_DEFAULTS.institutionName;
    const normalizedSiteUrl = String(siteUrl || '').replace(/\/+$/, '');
    const normalizedImageUrl =
        imageUrl || (normalizedSiteUrl ? `${normalizedSiteUrl}/logo512.png` : '');

    return {
        title,
        description,
        siteName,
        siteUrl: normalizedSiteUrl,
        imageUrl: normalizedImageUrl,
    };
}

export function setNamedMetaTag(name, content) {
    if (!content) return;
    let el = document.querySelector(`meta[name="${name}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute('name', name);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

export function setPropertyMetaTag(property, content) {
    if (!content) return;
    let el = document.querySelector(`meta[property="${property}"]`);
    if (!el) {
        el = document.createElement('meta');
        el.setAttribute('property', property);
        document.head.appendChild(el);
    }
    el.setAttribute('content', content);
}

export function applySiteMetaTags(bundle) {
    if (!bundle) return;

    document.title = bundle.title;
    setNamedMetaTag('description', bundle.description);
    setPropertyMetaTag('og:type', 'website');
    setPropertyMetaTag('og:site_name', bundle.siteName);
    setPropertyMetaTag('og:title', bundle.title);
    setPropertyMetaTag('og:description', bundle.description);
    setPropertyMetaTag('og:url', bundle.siteUrl);
    setPropertyMetaTag('og:image', bundle.imageUrl);
    setNamedMetaTag('twitter:card', 'summary_large_image');
    setNamedMetaTag('twitter:title', bundle.title);
    setNamedMetaTag('twitter:description', bundle.description);
    setNamedMetaTag('twitter:image', bundle.imageUrl);
}
